import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { lifecycle, compose, withHandlers, withProps } from 'recompose'
import { push } from 'react-router-redux'

import * as ProfileActions from 'modules/profile/actions'
import * as ProfileSelectors from 'modules/profile/selectors'
import * as UserActions from 'modules/user/actions'
import * as UserSelectors from 'modules/user/selectors'
import * as OrgActions from 'modules/org/actions'
import * as RoutingSelectors from 'modules/routing/selectors'
import { page, track } from 'utils/trackingUtils'
import ProfileDetails from './component'

import { uploadFile } from 'modules/file/api'

import { isURL } from 'validator'

const mapStateToProps = state => ({
  companyName: ProfileSelectors.getCompanyName(state),
  companyUrl: ProfileSelectors.getCompanyUrl(state),
  avatarUrl: UserSelectors.getAvatarUrl(state),
  pathname: RoutingSelectors.getPathname(state),
  name: UserSelectors.getName(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setCompanyName: ProfileActions.setCompanyName,
    setCompanyUrl: ProfileActions.setCompanyUrl,
    updateEmbed: OrgActions.updateEmbed,
    updateUser: UserActions.updateUser,
    setAvatarUrl: UserActions.setAvatarUrl,
    updateOrgProperties: OrgActions.updateOrgProperties,
    push,
  }, dispatch)
})

export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.updateOrgProperties({ properties: { lastStep: this.props.pathname } })
      page('Onboarding Profile Setup', {
        context: 'widget-onboarding',
      })
    },
  }),
  withHandlers({
    onCompanyNameChange: props => event => {
      props.actions.setCompanyName(event.target.value)
    },
    onCompanyUrlChange: props => event => {
      props.actions.setCompanyUrl(event.target.value)
    },
    onDrop: props => (files) => {
      uploadFile(files[0])
      .then(response => {
        const newFileUrl = response.downloadUrl
        props.actions.setAvatarUrl(newFileUrl)
      })
    },
    onContinueClick: props => () => {
      track('Onboarding Profile Setup Completed', {
        context: 'widget-onboarding',
      })
      props.actions.updateEmbed([{
        operation: 'set',
        value: props.companyName,
        property: 'organizationName',
      }, {
        operation: 'set',
        value: props.companyUrl,
        property: 'organizationUrl',
      }])
      const embedUpdates = []
      if (props.avatarUrl) {
        embedUpdates.push({
          operation: 'set',
          value: 'CUSTOM',
          property: 'theme.userListMode',
        })
        embedUpdates.push({
          operation: 'set',
          value: [props.userId],
          property: 'theme.userList',
        })

        props.actions.updateUser({
          avatarUrl: props.avatarUrl,
        })

      }
      if (embedUpdates.length > 0) {
        props.actions.updateEmbed(embedUpdates)
      }
      props.actions.push('/setup/touchless/install')
    },
  }),
  withProps(props => {
    return {
      disabled: !props.companyName || !props.companyUrl || !isURL(props.companyUrl)
    }
  })
)(ProfileDetails)



// WEBPACK FOOTER //
// ./src/layouts/ProfileDetails/index.js